if (!customElements.get('read-more-text')) {
  customElements.define(
    'read-more-text',
    class ReadMoreText extends HTMLElement {
      constructor() {
        super();
        
        // Configuración
        this.charLimit = parseInt(this.getAttribute('char-limit')) || 300;
        this.readMoreText = this.getAttribute('read-more-text') || '...leer más';
        this.readLessText = this.getAttribute('read-less-text') || 'leer menos';
        
        this.init();
      }

      init() {
        // Obtener el texto completo
        const fullText = this.textContent.trim();
        
        // Solo aplicar si excede el límite
        if (fullText.length > this.charLimit) {
          const firstPart = fullText.substring(0, this.charLimit);
          const secondPart = fullText.substring(this.charLimit);
          
          // Construir el HTML
          this.innerHTML = `
            <span class="first-section">${firstPart}</span>
            <span class="second-section m:hidden">${secondPart}</span>
            <button type="button" class="read-more-btn" aria-expanded="false">
              <span class="read-more-label">${this.readMoreText}</span>
              <span class="read-less-label m:hidden">${this.readLessText}</span>
            </button>
          `;
          
          // Agregar evento al botón
          const button = this.querySelector('.read-more-btn');
          button.addEventListener('click', () => this.toggleReadMore());
        }
      }

      toggleReadMore() {
        const secondSection = this.querySelector('.second-section');
        const button = this.querySelector('.read-more-btn');
        const readMoreLabel = this.querySelector('.read-more-label');
        const readLessLabel = this.querySelector('.read-less-label');
        
        // Toggle de visibilidad
        secondSection.classList.toggle('m:hidden');
        readMoreLabel.classList.toggle('m:hidden');
        readLessLabel.classList.toggle('m:hidden');
        
        // Actualizar aria-expanded
        const isExpanded = !secondSection.classList.contains('m:hidden');
        button.setAttribute('aria-expanded', isExpanded);
        
        // Scroll suave al colapsar (opcional)
        if (!isExpanded) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}